import React from 'react'
import BackButton from './BackButton';

const BackToLoginButton = () => {
  return (
    <BackButton to="/auth/login" backLabel="main.back_to_logn" />
  )
}

export default BackToLoginButton